import {
	ProjectBudget,
	ProjectType,
	RetainerBudget,
} from '@/generated/graphql';

export const DEDUCT_TOOLTIP_KEYS: Record<string, Record<string, string>> = {
	[ProjectType.Regular]: {
		[ProjectBudget.Manual]:
			'project_include_in_revenue_one_off_manual_tooltip',
		[ProjectBudget.Quote]:
			'project_include_in_revenue_one_off_quoted_tooltip',
	},
	[ProjectType.Retainer]: {
		[RetainerBudget.Manual]:
			'project_include_in_revenue_retainer_manual_tooltip',
		[RetainerBudget.Quote]:
			'project_include_in_revenue_retainer_quoted_tooltip',
	},
};

export const ProjectTypeType = {
	REGULAR: 'regular',
	RETAINER: 'retainer',
	INTERNAL: 'internal',
} as const;

export const DefaultRetainerFrequency = 1;
export const DefaultRetainerNoOfPeriods = 1;

export const RevenueTypeId = {
	SERVICE: '0',
	ROLES: '1',
} as const;

export const RevenueCalculations = [
	{
		id: '0',
		title: 'project_service_based_prices',
	},
	{
		id: '1',
		title: 'project_role_based_prices',
	},
];
